import React from 'react'

import { usePWAInstall } from '@/b-components/pwa/use-pwa-install'
import {
  SC_InstallPrompt,
  SC_InstallContent,
  SC_InstallTitle,
  SC_InstallDescription,
  SC_InstallActions,
  SC_InstallButton,
  SC_CloseButton
} from './styled'


export const PWAInstallPrompt: React.FC = () => {
  const {
    canInstall,
    isInstalled,
    supportsPromptAPI,
    installInstructions,
    promptInstall,
    dismissPrompt,
    isDismissed
  } = usePWAInstall()

  const handleInstall = async () => {
    if (supportsPromptAPI) {
      // Стандартный способ для Chrome и других Chromium браузеров
      await promptInstall()
    } else {
      // Для браузеров без поддержки beforeinstallprompt (включая Яндекс.Браузер)
      // Показываем инструкции
      alert(installInstructions)
      dismissPrompt()
    }
  }

  const handleDismiss = () => {
    dismissPrompt()
  }

  // Не показываем промпт если PWA уже установлено или отклонено
  if (isInstalled || isDismissed || !canInstall) {
    return null
  }


  return (
    <SC_InstallPrompt>
      <SC_CloseButton onClick={handleDismiss}>
        ✕
      </SC_CloseButton>

      <SC_InstallContent>
        <SC_InstallTitle>Установить ЭРА</SC_InstallTitle>

        <SC_InstallDescription>
          Установите приложение для быстрого доступа и работы без браузера
        </SC_InstallDescription>
      </SC_InstallContent>

      <SC_InstallActions>
        <SC_InstallButton onClick={handleDismiss}>
          Позже
        </SC_InstallButton>

        <SC_InstallButton $variant='primary' onClick={handleInstall}>
          Установить
        </SC_InstallButton>
      </SC_InstallActions>
    </SC_InstallPrompt>
  )
}
